import React from 'react';
import { formatDetailedTime, formatDate, getBrandingText } from '../templateUtils';

const OriginalTemplate = ({
  language = 'zh',
  calculatedDays = 0,
  relationshipLabel = '在一起',
  detailedTime = null,
  anniversaryDate = null,
  anniversaryType = 'couple',
  quote = ''
}) => {
  return (
    <div
      style={{
        width: '1080px',
        height: '1350px',
        background: 'linear-gradient(135deg, #fce7f3 0%, #fbcfe8 50%, #f9a8d4 100%)',
        overflow: 'hidden',
        fontFamily: 'Arial, sans-serif',
        position: 'relative'
      }}
    >
      {/* 浮動愛心裝飾 */}
      <div style={{ position: 'absolute', top: '100px', left: '80px', opacity: 0.15 }}>
        <svg width="80" height="80" viewBox="0 0 24 24" fill="#ec4899">
          <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
        </svg>
      </div>
      <div style={{ position: 'absolute', top: '200px', right: '120px', opacity: 0.1 }}>
        <svg width="120" height="120" viewBox="0 0 24 24" fill="#ec4899">
          <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
        </svg>
      </div>
      <div style={{ position: 'absolute', bottom: '150px', left: '150px', opacity: 0.12 }}>
        <svg width="100" height="100" viewBox="0 0 24 24" fill="#ec4899">
          <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
        </svg>
      </div>

      {/* 柔和光暈 */}
      <div style={{
        position: 'absolute', top: '-10%', right: '-10%',
        width: '500px', height: '500px', borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(236, 72, 153, 0.3) 0%, transparent 70%)',
        filter: 'blur(80px)'
      }} />

      {/* 主內容區 */}
      <div style={{ position: 'relative', zIndex: 10, height: '100%', display: 'flex', flexDirection: 'column', padding: '100px 80px 80px 80px' }}>

        {/* 頂部愛心 */}
        <div style={{ textAlign: 'center', marginBottom: '70px' }}>
          <div style={{
            display: 'inline-block', padding: '30px',
            background: 'rgba(255, 255, 255, 0.5)', borderRadius: '50%',
            boxShadow: '0 20px 60px rgba(236, 72, 153, 0.3)'
          }}>
            <svg width="160" height="160" viewBox="0 0 24 24" fill="none">
              <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" fill="#ec4899" />
            </svg>
          </div>
        </div>

        {/* 中間內容 */}
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', textAlign: 'center' }}>
          <div style={{ fontSize: '240px', fontWeight: '800', color: '#be185d', lineHeight: '1', marginBottom: '30px', fontFamily: 'Arial, sans-serif', letterSpacing: '-8px', textShadow: '0 10px 30px rgba(190, 24, 93, 0.3)' }}>
            {calculatedDays}
          </div>
          <div style={{ fontSize: '54px', fontWeight: '600', color: '#9f1239', marginBottom: '60px' }}>
            {language === 'zh' ? `${relationshipLabel}的日子` : `days ${relationshipLabel}`}
          </div>
          {detailedTime && (
            <div style={{ display: 'inline-block', fontSize: '42px', color: '#be185d', fontWeight: '500', marginBottom: '50px', padding: '20px 50px', background: 'rgba(255, 255, 255, 0.6)', borderRadius: '60px', boxShadow: '0 10px 30px rgba(236, 72, 153, 0.2)' }}>
              {formatDetailedTime(detailedTime, language)}
            </div>
          )}
          {quote && (
            <div style={{ fontSize: '36px', color: '#9f1239', fontStyle: 'italic', lineHeight: '1.6', maxWidth: '800px', margin: '0 auto', padding: '0 40px' }}>
              "{quote}"
            </div>
          )}
        </div>

        {/* 底部信息 */}
        <div style={{ textAlign: 'center', paddingTop: '60px', borderTop: '3px solid rgba(236, 72, 153, 0.3)' }}>
          {anniversaryDate && (
            <div style={{ fontSize: '32px', color: '#be185d', marginBottom: '24px' }}>
              {formatDate(anniversaryDate, language)}
            </div>
          )}
          <div style={{ fontSize: '38px', fontWeight: '700', color: '#ec4899', textTransform: 'uppercase', letterSpacing: '3px', marginBottom: '16px' }}>
            {getBrandingText(anniversaryType, language)}
          </div>
          <div style={{ fontSize: '28px', color: '#be185d', opacity: 0.7 }}>
            lovedays.homy.hk
          </div>
        </div>
      </div>
    </div>
  );
};

export default OriginalTemplate;